export const cvConstants = {
  UPLOAD_START: "CV_UPLOAD_START",
  UPLOAD_SUCCESS: "CV_UPLOAD_SUCCESS",

  FETCH_CV_START: "CV_FETCH_CV_START",
  FETCH_CV_SUCCESS: "CV_FETCH_CV_SUCCESS",

  FETCH_USERS_CV_START: "CV_FETCH_USERS_CV_START",
  FETCH_USERS_CV_SUCCESS: "CV_FETCH_USERS_CV_SUCCESS"
};
